<template>
  <div>
    <b-row align-v="center"
           class="text-center">
      <b-col cols="auto">
        OPEN CALL :
      </b-col>
      <b-col class="text-left">
        <div style="width: 195px;">
          <b-form-select v-if="!loading"
                         v-model="selectedCall"
                         :options="calls"/>
          <b-spinner v-else
                     class="ml-2 mt-1"
                     variant="info"/>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    props: {
      load_data_for: undefined,
      value: undefined,
      id: undefined,
      allCalls: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        proposals: this.value,
        selectedCall: '',
        proposals_cached: {},
      };
    },
    methods: {
      update_proposals() {
        if (!this.is_call_cached()) {
          // emit signal to load proposal in parent for specific call
          this.$emit('load-data', this.selectedCall);
        } else {
          // emit proposal from cache to update in the parent widget
          this.$emit('update-proposals', this.proposals_cached[this.selectedCall]);
        }
      },
      is_call_cached() {
        return Object.keys(this.proposals_cached).includes(this.selectedCall);
      },
      setup(proposal) {
        this.proposals_cached[this.selectedCall] = proposal;
      },
      refresh() {
        this.$emit('load-data', this.selectedCall);
      },
    },
    watch: {
      selectedCall() {
        this.update_proposals();
        this.$emit('selected-call-change', this.selectedCall);
      },
      proposals() {
        this.$emit('input', this.proposals);
      },
      value() {
        this.proposals = this.value;
      },
    },
    computed: {
      calls() {
        const callsNames = this.$store.state.calls.calls
          .reduce((listOfCallNames, { states, name }) => {
            if (states.name !== 'deleted') {
              listOfCallNames.push(name);
            }
            return listOfCallNames;
          }, []);

        if (this.allCalls) {
          callsNames.push('All calls');
        }
        return callsNames;
      },
    },
    created() {
      setTimeout(() => {
        const parent = this.getParentById(this.id);
        parent.$on('setup-proposal', this.setup);
        parent.$on('refresh-proposals', this.refresh);

        // load and setup the default selected call (the newest)
        this.$store.dispatch('calls/load_calls')
          .then(() => this.selectedCall = this.calls[0]);
      }, 0);
    },
  };
</script>

<style scoped>

</style>
